import React from 'react';
import ColorBar from '../components/ColorBar/ColorBar';
import FooterComp from '../components/Footer/Footer';
import HeaderComp from '../components/Header/Header';
import ProductFeatureBadgeWidget from '../components/ProductFeatureBadgeWidget/ProductFeatureBadgeWidget';
import Player from '../components/VideoPlayer/Player';
import ProductBadgeWidget from '../components/ProductBadgeWidget/ProductBadgeWidget';
import ProductVideoContent from '../components/ProductVideoContent/ProductVideoContent';
import ProductUsageCardWidget from '../components/ProductUsageCardWidget/ProductUsageCardWidget';
import ProductFeatureContent from '../components/ProductFeatureContent/ProductFeatureContent';
import ImageTableCausel from '../components/ImageTableCausel/ImageTableCausel';
import config from '../config/config';
import SetHeaders from '../config/SetHeaders';
import seo from '../config/seo';
import Head from 'next/head';
import axios from 'axios';

const SportsTowelContainer = ({ Header, Body, Footer, response }: any) => {

  const components = (typeName: any, compData: any, key: number) => {
    switch (typeName) {
      case 'towel.video-player-widget':
        return (
          <div key={key} className="towel.video-player-widget">
            <Player data={compData} type={false} />
          </div>
        );
      case 'towel.product-usage-card-widget':
        return <ProductUsageCardWidget data={compData} key={key} />;
      case 'towel.product-video-content':
        return <ProductVideoContent data={compData} key={key} />;
      case 'towel.microfiber-widget':
        return <ProductFeatureContent data={compData} key={key} />;
      case 'towel.activity-widget':
        return <ImageTableCausel data={compData} key={key} />;
      case 'towel.group-color-bar':
        return <ColorBar data={compData} key={key} />;
      case 'towel.group-product-feature-badge-widget':
        return <ProductFeatureBadgeWidget data={compData} key={key} />;
      case 'product.product-badges':
        return <ProductBadgeWidget popup={true} data={compData.Badges} key={key} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <React.Fragment>
        {response && !response.Seo && (
          <Head>
            <title>{seo.sportTowel}</title>
          </Head>
        )}
        {response && <SetHeaders HEADERS={response} />}
        {Header && <HeaderComp HeaderValue={Header} />}
        <div className="app-body">
          {Body &&
            Body.length > 0 &&
            Body.map((data: any, i: number) => {
              return components(data.__component, data, i);
            })}
        </div>
        {Footer && <FooterComp data={Footer} />}
      </React.Fragment>
    </div>
  );
};

export async function getStaticProps() {
  const { data } = await axios.get(config.endpoints.sporttowel)
  return {
    props: {
      Header: data.Header,
      Body: data.Body,
      Footer: data.Footer.Footer,
      response: data
    },
    revalidate: 3600
  }
}

export default SportsTowelContainer
